import React from 'react'
import PropTypes from 'prop-types'

import { getUserName } from 'Global/Helpers/userHelpers'

const ReservationUpdatedBy = props => {
  const { reservation } = props

  if (reservation.updatedBy) {
    if (reservation.updatedBy.id) {
      if (reservation.updatedBy.id !== reservation.createdBy.id) {
        return <span>{` (Last updated by ${getUserName(reservation.updatedBy)})`}</span>
      }
    }
  }

  return null
}

ReservationUpdatedBy.propTypes = {
  reservation: PropTypes.object.isRequired,
}

export default ReservationUpdatedBy
